

























































































































































































import Vue, { PropOptions } from 'vue';
import TopBar from '@/components/TopBar.vue';
import DispsetModal from '@/components/DispsetModal.vue';
import * as TypeVariable from '@/parts/VariableInput.vue';
import parts from '@/parts';
import * as PClass from '@/class';
import * as Models from '@/class/models/views';
import mv from './mixins-views';
import InfiniteLoading from 'vue-infinite-loading';

export default Vue.extend({
  name: 'Mail',
  mixins: [mv],
  components: {
    ...parts, TopBar, DispsetModal, InfiniteLoading,
  },
  props: {
    myData: Object as PropOptions<Models.ICoordinator>,
    confirmDialog: Function,
    sendFlag: Boolean,
    localDatas: Object as PropOptions<Models.ILocalDatas>,
    getDatas: Object as PropOptions<Models.IGetDatas>,
  },
  computed: {
    selectKey(): string {
      return this.annkenn ? 'annkenn' : 'engineer';
    },
    mailTrDatas(): any[] {
      // console.log(this.getMailDatas)
      return this.getDatas.getMailDatas.map((v) => {
        const coordinator = this.getDatas.getCoordinatorDatas.find((s) => (s.id === v.responsibleID));

        let sendStatus = '';
        switch (v.sendStatus) {
          case 0:
            sendStatus = '完了'
            break;
          case 1:
            sendStatus = v.sendType === 2 ? '予約中' : '待機中';
            break;
          case 10:
            sendStatus = '送信中'
            break;
          case 11:
            sendStatus = '完了'
            break;
          case 88:
            sendStatus = '問題有'
            break;
          case 99:
            sendStatus = '取消'
            break;
          default:
            sendStatus = ''
            break;
        }
        return {
          category: v.engineerID === 0 ? '案件' : '要員' ,
          responsibleName: coordinator?.coordinatorName,
          typeName: v.sendType === 2 ? '予約' : '通常',
          subject: v.subject,
          text: v.text,
          createdDate: v.createdDate,
          id: v.id,
          success: v.success,
          failure: v.failure,
          status: v.sendStatus,
          sendStatus,
          sendDate: v.sendStatus !== 0 ? v.sendDate : '過去データ',
          stopFlag: v.createdID === this.myData.id,
        }
      });
    },
    mailDispThDatas(): any[] {
      // console.log('aa', this.localData)
      if (this.localData.disp) {
        return this.mailThDatas.filter((v, n) => (this.localData.disp[n]))
      } else {
        return this.mailThDatas
      }
    },
    selectTrDatas(): any[] {
      return this.selectDatas ? this.selectDatas
        .map((v) => {
          if (v) {
            const responsiblecoordinator = this.getDatas.getCoordinatorDatas.find((s) => (s.id === v.responsibleID));
            v.responsibleName = responsiblecoordinator ? responsiblecoordinator.coordinatorName : v.responsibleID === 0 ? '未設定' : '削除済';
            v.sendDate = v.sendDate ? v.sendDate === 'Invalid date' ? '過去データ' : v.sendDate : '未送信';
          }
          return v
        }) : [];
    },
    selectHrDisp(): any[] {
      if (this.selectHrlocalData.disp) {
        return this.selectHr.filter((v, n) => (this.selectHrlocalData.disp[n]))
      } else {
        return this.selectHr
      }
    },
    sendEditClients(): any[] {
      return this.searchWordModal === '' ?
        this.sendEditData.clients
          : this.sendEditData.clients.filter((v) => (JSON.stringify(v).indexOf(this.searchWordModal) > 0));
    },
  },
  watch: {
    sendFlag() {
      if (this.sendFlag === true) {
        // console.log('kita')
        this.fncGetDatas(true);
        this.onClickCancel();
      }
    },
  },
  data() {
    return {
      getCordinatorRankDatas: [] as Models.ICoordinatorRank[],
      selectDatas: [] as any[],
      selectHr: [] as TypeVariable.IVariableInput[],
      items: [
        [
          {key: 'engineerName', name: 'エンジニア名', sort: true},
          {key: 'initials', name: '頭文字', sort: true},
          {key: 'responsibleName', name: '担当者', sort: true},
          {key: 'sendDate', name: '送信日時', sort: true},
          {key: 'createDate', name: '作成日', sort: true},
          {key: 'updateDate', name: '更新日', sort: true},
        ] as TypeVariable.IVariableInput[],
        [
          {key: 'subject', name: '件名', class: 'subject'},
          {key: 'responsibleName', name: '担当者', sort: true},
          {key: 'introduction', name: '本文'},
          {key: 'sendDate', name: '送信日時', sort: true},
          {key: 'createDate', name: '作成日', sort: true},
          {key: 'updateDate', name: '更新日', sort: true},
        ] as TypeVariable.IVariableInput[],
      ],
      mailThDatas: [
        {key: 'category', name: 'カテゴリー'},
        {key: 'responsibleName', name: '担当者', sort: true},
        {key: 'subject', name: '件名', class: 'subject'},
        {key: 'text', name: '本文'},
        {key: 'createdDate', name: '作成日時', sort: true},
        {key: 'sendStatus', name: '送信状況', sort: true},
        {key: 'sendDate', name: '送信予約日時', sort: true},
        {key: 'success', name: '送信成功数'},
        {key: 'failure', name: '送信失敗数'},
      ] as TypeVariable.IVariableInput[],
      searchWord: '',
      companyModal: false,
      annkenn: false,
      teiki: false,
      sendEditData: {} as Models.ISendEditData,
      ngIDs: [] as number[],
      searchWordClients: '',
      sendClients: [] as number[],
      tmpSendClients: [] as number[],
      selectHrlocalData: {} as Models.ILocalData,
      localDataAnnkenn: {} as Models.ILocalData,
      localDataEngineer: {} as Models.ILocalData,
      localData: {} as Models.ILocalData,
      // listDispModal: false,
      listDispModalMessage: '',
      // sending: false,
      mailLoading: true,
      rawMailData: [] as Models.IMail[],
      searchWordModal: '',
      showDetails: false,
      detailDatas: {},
      dispSearchWord: '',
      dispDataMaxCount: 0,
      stackDatas: [] as any[],
      selectDispSearchWord: '',
      selectDataMaxCount: 0,
      selectStackDatas: [] as any[],
      backEngineerDatas: [] as any[],
      backEngineerCount: 0,
      backAnnkennDatas: [] as any[],
      backAnnkennCount: 0,
    };
  },
  async mounted() {
    const localSet = (v: string, constractArray: any[], localDatasData: Models.ILocalData) => {
      // データ初期化
      const localData = new Models.CLocalData(v, constractArray)
      // データ読み込み
      if (localDatasData) {
        localData.target = localDatasData.target;
        localData.asc = localDatasData.asc;
        if (localDatasData.disp) {
          if (localDatasData.disp.length === localData.disp.length) {
            localData.disp = localDatasData.disp;
          }
        }
        localData.word = localDatasData.word;
        localData.searchIDs = localDatasData.searchIDs;
      }
      return localData;
    }
    // ローカルデータ初期化
    this.localDataEngineer = localSet('sendDate', this.items[0], this.localDatas.mailEngineer);
    this.localDataAnnkenn = localSet('sendDate', this.items[1], this.localDatas.mailAnnkenn);
    this.localData = localSet('createdDate', this.mailThDatas, this.localDatas.mail);
    // データ取得
    await this.fncGetDatas(true, true);
  },
  methods: {
    async fncGetDatas(initials: boolean, mounted?: boolean) {
      // 共通初回操作
      const firstFlag = mounted;
      let coordinatorIDs = [] as number[];
      let searchWord = '';
      let skip = this.getDatas.getMailDatas.length === 0 ? 0 : Math.floor(this.getDatas.getMailDatas.length / 100)

      // イニシャライズフラグ
      if (initials) {
        this.$emit('loading', true);
        this.dispDataMaxCount = 0;
        skip = 0;
      }

      // searchフラグ検索
      if (this.localData.word && this.localData.word !== '') {
        coordinatorIDs = this.localData.searchIDs;
        searchWord = this.localData.word;
        this.dispSearchWord = searchWord;
      }

      (this as any).fncAntiLoading();
      const api = new PClass.API();
      const res = await api.get<Models.VGetDatas>('mail', {firstFlag, skip, coordinatorIDs, searchWord, target: this.localData.target, asc: this.localData.asc} as Models.ISortData);

      if (!res.result.error) {
        if (firstFlag) {
          this.getDatas.getCoordinatorDatas = res.data.coordinators;
          this.getDatas.getClientDatas = res.data.clients;
          this.getCordinatorRankDatas = res.data.coordinatorsRanks;
        }
        if (skip === 0) {
          this.dispDataMaxCount = res.data.count;
          this.stackDatas = res.data.datas;
          this.getDatas.getMailDatas = this.stackDatas.slice(0, 50);
        } else {
          this.stackDatas = res.data.datas;
          this.getDatas.getMailDatas = this.getDatas.getMailDatas.concat(this.stackDatas.slice(0, 50))
        }
      } else {
        // this.$emit('change', NOC.APP.MODE.LOGIN);
        this.$emit('info', 'エラーが発生しました。');
        (this.$refs.infiniteLoading as any).stateChanger.complete();
      }

      if (initials) {
        this.sendEditData = new Models.CSendEditData();
        this.rawMailData = [];
        (this.$refs.infiniteLoading as any).stateChanger.reset();
        this.$emit('loading', false);
      }
    },
    async fncGetDatasKey(key?: string) {
      this.$emit('loading', true);
      // ローカルデータ更新
      if (key) {
        if (this.localData.target === key) {
          this.localData.asc = !this.localData.asc
        } else {
          this.localData.target = key;
          this.localData.asc = false;
        }
      } else {
        const responsiblecoordinator = this.getDatas.getCoordinatorDatas.filter((s) => (s.coordinatorName.indexOf(this.dispSearchWord) >= 0));
        this.localData.searchIDs = responsiblecoordinator.map((v) => v.id);
        this.localData.word = this.dispSearchWord;
      }
      this.localDatas.mail = this.localData;
      this.$emit('setLocalDatas')
      // データ取得
      await this.fncGetDatas(true);
      this.$emit('loading', false);
    },
    async infiniteHandler($state: any) {
      this.getDatas.getMailDatas = this.getDatas.getMailDatas.concat(this.stackDatas.slice(50))
      this.stackDatas = [];
      if (this.dispDataMaxCount <= this.getDatas.getMailDatas.length) {
        $state.complete();
      } else {
        await this.fncGetDatas(false);
        if (this.dispDataMaxCount <= this.getDatas.getMailDatas.length) {
          $state.complete();
        } else {
          $state.loaded();
        }
      }
    },
    async onClickClear() {
      this.dispSearchWord = '';
      if (!this.localData.word || this.localData.word === '') {
        return;
      }
      await this.fncGetDatasKey();
    },
    async fncGetSelectDatas(initials: boolean) {
      let coordinatorIDs = [] as number[];
      let searchWord = '';
      let target = '';
      let asc = false;
      let skip = this.selectDatas.length === 0 ? 0 : Math.floor(this.selectDatas.length / 100)

      // イニシャライズフラグ
      if (initials) {
        this.$emit('loading', true);
        this.selectDataMaxCount = 0;
        skip = 0;
        if (this.annkenn) {
          this.backAnnkennDatas = [];
          this.backAnnkennCount = 0;
        } else {
          this.backEngineerDatas = [];
          this.backEngineerCount = 0;
        }
      }

      // searchフラグ検索
      let localData = {} as Models.ILocalData;
      localData = this.annkenn ? this.localDataAnnkenn : this.localDataEngineer;
      if (localData.word && localData.word !== '') {
        coordinatorIDs = localData.searchIDs;
        searchWord = localData.word;
        this.selectDispSearchWord = searchWord;
      }
      target = localData.target;
      asc = localData.asc;

      (this as any).fncAntiLoading();
      const api = new PClass.API();
      const res = await api.get<Models.VGetDatas>(this.selectKey, {mail: true, skip, coordinatorIDs, searchWord, target, asc} as Models.ISortData);

      if (!res.result.error) {
        if (skip === 0) {
          this.selectDataMaxCount = res.data.count;
          this.selectStackDatas = res.data.datas;
          this.selectDatas = this.selectStackDatas.slice(0, 50);
        } else {
          this.selectStackDatas = res.data.datas;
          this.selectDatas = this.selectDatas.concat(this.selectStackDatas.slice(0, 50))
        }
      } else {
        // this.$emit('change', NOC.APP.MODE.LOGIN);
        this.$emit('info', 'エラーが発生しました。');
        if (this.$refs.selectInfiniteLoading) {
          (this.$refs.selectInfiniteLoading as any).stateChanger.complete();
        }
      }

      if (initials) {
        if (this.$refs.selectInfiniteLoading) {
          (this.$refs.selectInfiniteLoading as any).stateChanger.reset();
        }
        this.$emit('loading', false);
      }

    },
    async fncGetSelectDatasKey(key?: string) {
      // ローカルデータ設定
      const localData = this.annkenn ? this.localDataAnnkenn : this.localDataEngineer;
      if (key) {
        if (localData.target === key) {
          localData.asc = !localData.asc
        } else {
          localData.target = key;
          localData.asc = false;
        }
      } else {
        const responsiblecoordinator = this.getDatas.getCoordinatorDatas.filter((s) => (s.coordinatorName.indexOf(this.selectDispSearchWord) >= 0));
        localData.searchIDs = responsiblecoordinator.map((v) => v.id);
        localData.word = this.selectDispSearchWord;
      }
      if (this.annkenn) {
        this.localDatas.mailAnnkenn = localData;
      } else {
        this.localDatas.mailEngineer = localData;
      }
      this.$emit('setLocalDatas')
      await this.fncGetSelectDatas(true);
    },
    async selectInfiniteHandler($state: any) {
      this.selectDatas = this.selectDatas.concat(this.selectStackDatas.slice(50))
      this.selectStackDatas = [];
      if (this.selectDataMaxCount <= this.selectDatas.length) {
        $state.complete();
      } else {
        await this.fncGetSelectDatas(false);
        if (this.selectDataMaxCount <= this.selectDatas.length) {
          $state.complete();
        } else {
          $state.loaded();
        }
      }
    },
    async onClickSelectClear() {
      this.selectDispSearchWord = '';
      const localData = this.annkenn ? this.localDataAnnkenn : this.localDataEngineer;
      if (!localData.word || localData.word === '') {
        return;
      }
      await this.fncGetSelectDatasKey();
    },
    async onClickSelectEdit(annkenn: boolean) {
      this.annkenn = annkenn;
      this.selectHr = annkenn ?  this.items[1] : this.items[0];
      this.selectHrlocalData = annkenn ? this.localDataAnnkenn : this.localDataEngineer;
      if (this.selectHrlocalData.word) {
        this.selectDispSearchWord = this.selectHrlocalData.word;
      }
      scrollTo(0, 0);
      if (this.backEngineerDatas.length > 0 && !this.annkenn) {
        this.selectDatas = this.backEngineerDatas;
        this.selectDataMaxCount = this.backEngineerCount;
      } else if (this.backAnnkennDatas.length > 0 && this.annkenn) {
        this.selectDatas = this.backAnnkennDatas;
        this.selectDataMaxCount = this.backAnnkennCount;
      } else {
        await this.fncGetSelectDatas(true);
      }
      (this as any).mixChangeMode(PClass.CONST.MODE.SELECT);
    },
    onClickBackList() {
      this.sendEditData = new Models.CSendEditData();
      scrollTo(0, 0);
      (this as any).mixChangeMode(PClass.CONST.MODE.SELECT);
    },
    onClickCancel() {
      if (this.annkenn) {
        this.backAnnkennDatas = this.selectDatas.concat(this.selectStackDatas.slice(50));
        this.backAnnkennCount = this.selectDataMaxCount;
      } else {
        this.backEngineerDatas = this.selectDatas.concat(this.selectStackDatas.slice(50));
        this.backEngineerCount = this.selectDataMaxCount;
      }
      // データクリア
      this.selectDispSearchWord = '';
      this.tmpSendClients = [];
      this.sendClients = [];
      this.selectDatas = [];
      this.selectStackDatas = [];
      this.sendEditData = new Models.CSendEditData();
      (this as any).mixChangeMode(PClass.CONST.MODE.NORMAL);
    },
    async onClickEngineerMailEdit(data: Models.IEngineer) {
      let change = true;
      const coordinator = this.getDatas.getCoordinatorDatas.find((s) => (s.id === data.responsibleID))
      if (coordinator) {

        const api = new PClass.API();
        const res = await api.get<Models.VEngineerReject>('engineer_reject', {id: data.id});
        if (!res.result.error) {
          // console.log(res.data);
          this.ngIDs = res.data.engineerReject.map((v) => (v.clientID));
        }
        this.sendEditData.coordinator =  coordinator;
        this.sendEditData.mail.subject = data.subject;
        // 送信者を元にフィルタリング
        const inputSendTargetRank = [] as number[];
        const userRank = this.getCordinatorRankDatas.find((v) => (v.coordinatorID === coordinator.id));
        if (userRank) {
          if (userRank.a) {inputSendTargetRank.push(1)}
          if (userRank.b) {inputSendTargetRank.push(2)}
          if (userRank.c) {inputSendTargetRank.push(3)}
          if (userRank.d) {inputSendTargetRank.push(4)}
        }
        this.sendEditData.clients = this.getDatas.getClientDatas.filter((v) => (v.engineerDelivery && !v.stopDelivery && inputSendTargetRank.indexOf(v.rank) > -1));
        this.sendClients = this.sendEditData.clients.map((v) => (v.id)).filter((h) => (this.ngIDs.indexOf(h) === -1));
        this.sendEditData.mail.text = coordinator.header + '\n' + data.introduction + 'メールを希望されない場合はお手数ですがご連絡をお願いいたします。' + '\n\n' + coordinator.footer;
        this.sendEditData.mail.attachmentName = data.attachmentName;
        this.sendEditData.mail.attachmentUrl = data.attachmentUrl;
        this.sendEditData.mail.engineerID = data.id;
      } else {
        this.$emit('info', '担当者を再度設定してください');
        change = false;
      }

      if (change) {
       (this as any).mixChangeMode(PClass.CONST.MODE.EDIT);
      }
    },
    async onClickAnnkenMailEdit(data: Models.IAnnkenn) {

      let id = 0;
      if (data.responsibleID === 0) {
        this.$emit('info', '担当者が未設定のため、\n自分（ログイン者）が担当者でメールが作成されます。');
        id = this.myData.id;
      } else {
        id = data.responsibleID;
      }
      let change = true;
      const coordinator = this.getDatas.getCoordinatorDatas.find((s) => (s.id === this.myData.id));
      if (coordinator) {
        // console.log(data.subject);
        // console.log(this.sendEditData.mail.subject)

        const api = new PClass.API();
        const res = await api.get<Models.VAnnkennReject>('annkenn_reject', {id: data.id});
        if (!res.result.error) {
          // console.log(res.data);
          this.ngIDs = res.data.annkennReject.map((v) => (v.clientID));
        }

        this.sendEditData.coordinator = coordinator;
        this.sendEditData.mail.subject = data.subject;
        // 送信者を元にフィルタリング
        const inputSendTargetRank = [] as number[];
        const userRank = this.getCordinatorRankDatas.find((v) => (v.coordinatorID === coordinator.id));
        if (userRank) {
          if (userRank.a) {inputSendTargetRank.push(1)}
          if (userRank.b) {inputSendTargetRank.push(2)}
          if (userRank.c) {inputSendTargetRank.push(3)}
          if (userRank.d) {inputSendTargetRank.push(4)}
        }
        this.sendEditData.clients = this.getDatas.getClientDatas.filter((v) => (v.annkennDelivery && !v.stopDelivery && inputSendTargetRank.indexOf(v.rank) > -1));
        this.sendClients = this.sendEditData.clients.map((v) => (v.id)).filter((h) => (this.ngIDs.indexOf(h) === -1));
        this.sendEditData.mail.text = coordinator.header + '\n' + data.introduction  + 'メールを希望されない場合はお手数ですがご連絡をお願いいたします。' + '\n\n' + coordinator.footer;
        this.sendEditData.mail.annkennID = data.id;
      } else {
        this.$emit('info', '担当者を再度設定してください');
        change = false;
      }

      if (change) {
        (this as any).mixChangeMode(PClass.CONST.MODE.EDIT);
      }
    },
    async onClickSet() {
      const sendDate = new Date();
      if (this.sendFlag) {
        this.sendEditData.mail.sendType = 1;
        this.sendEditData.mail.sendDate = sendDate;
        this.sendEditData.mail.responsibleID = this.sendEditData.coordinator.id;
        const mailData = {} as Models.VSendData;
        mailData.mail = this.sendEditData.mail;
        mailData.clients = this.sendClients;
        this.$emit('sendSet', mailData);

      } else {
        this.$emit('info', 'メール送信中のため送信できません。');
      }
    },
    async onClickSetCancel(id: number) {
      const mailData =  this.rawMailData.find((v) => (v.id = id))
      if (mailData) {
        this.$emit('setCancel', mailData);
      }
    },
    async onClickEditMode(id: number) {
      const targetMail = this.getDatas.getMailDatas.filter((v) => (v.id === id));
      // console.log('data', targetMail[0]);
      this.sendEditData.mail = targetMail[0];

      let change = true;
      const coordinator = this.getDatas.getCoordinatorDatas.find((s) => (s.id === this.sendEditData.mail.responsibleID))
      if (coordinator) {

        const api = new PClass.API();
        let res;
        if (this.sendEditData.mail.annkennID === 0) {
          this.sendEditData.clients = this.getDatas.getClientDatas.filter((v) => (v.engineerDelivery && !v.stopDelivery));
          res = await api.get<Models.VEngineerReject>('engineer_reject', {id: this.sendEditData.mail.engineerID});
          if (!res.result.error) {
            // console.log(res.data);
            this.ngIDs = res.data.engineerReject.map((v) => (v.clientID));
          } else {
            this.$emit('info', '通信に失敗しました。');
            change = false;
          }
        } else {
          this.sendEditData.clients = this.getDatas.getClientDatas.filter((v) => (v.annkennDelivery && !v.stopDelivery));
          res = await api.get<Models.VAnnkennReject>('annkenn_reject', {id: this.sendEditData.mail.annkennID});
          if (!res.result.error) {
            // console.log(res.data);
            this.ngIDs = res.data.annkennReject.map((v) => (v.clientID));
          } else {
            this.$emit('info', '通信に失敗しました。');
            change = false;
          }
        }

        res = await api.get<any>('mail/reserve', {id: this.sendEditData.mail.id});
        if (!res.result.error) {
          // console.log('anken', res.data);
          this.sendClients = res.data.ids;
        } else {
          this.$emit('info', '通信に失敗しました。');
          change = false;
        }
        this.sendEditData.coordinator =  coordinator;
      } else {
        this.$emit('info', '担当者を設定してください');
        change = false;
      }

      if (change) {
        scrollTo(0, 0);
        (this as any).mixChangeMode(PClass.CONST.MODE.EDIT);
      }
    },
    onClickEditSendClients() {
      this.tmpSendClients = this.sendClients;
      this.companyModal = true;
    },
    onClickDecideSendClients() {
      this.sendClients = this.tmpSendClients;
      this.companyModal = false;
    },
    onClickDesideListDispModal(list: boolean[], meessage: string) {
      switch (meessage) {
        case 'mail' :
          this.localData.disp = list;
          this.localDatas.mail = this.localData;
          break;
        case 'annkenn' :
          this.localDataAnnkenn.disp = list;
          this.localDatas.mailAnnkenn = this.localDataAnnkenn;
          break;
        case 'engineer' :
          this.localDataEngineer.disp = list;
          this.localDatas.mailEngineer = this.localDataEngineer;
          break;
      }
      this.$emit('setLocalDatas')
      this.listDispModalMessage = '';
    },
    async onShowDetail(data: any ) {
      this.detailDatas = data;
      // console.log(data.id);
      // console.log(this.getDatas.getMailDatas.filter((v) => (v.id === data.id)))
      const rawMailData = this.getDatas.getMailDatas.find((v) => (v.id === data.id));
      if (rawMailData) {
        data.createUser = this.getCoordinaterName(rawMailData.createdID);
        data.sendUser = this.getCoordinaterName(rawMailData.responsibleID, true);
      }
      this.detailDatas = data;
      this.showDetails = true;
    },
    async oncloseDetail() {
      this.showDetails = false;
    },
    getCoordinaterName(id: number, mail?: boolean) {
      const responsiblecoordinator = this.getDatas.getCoordinatorDatas.find((s) => (s.id === id))
      let rValue = '';
      if (responsiblecoordinator) {
        rValue = responsiblecoordinator.coordinatorName;
        if (mail) {
          rValue = `${rValue} <${responsiblecoordinator.coordinatorMail}>`;
        }
      }
      return rValue
    },
  },
});

